import { Checkbox } from '@mui/material';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { UPDATE_LISTINGS_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { updateListing } from 'modules/authorizations/store/actions/homesale.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';

const ReferralFeesCard = (props) => {

  const [isLoading, setIsLoading] = useState(false);

  const { listingInfo, isReadOnly, id } = props;

  const tabs = [
    { header: 'Referral Fees', order: 1, iconPath: ['fas', 'dollar-sign'] },
  ];

  const summaries = [
    { header: 'Referral Due', accessorKey: 'referralDue', type: 'dropdown', options: ['Yes', 'No'], required: false, value: listingInfo ? listingInfo.referralDue : '', tab: 1 },
    { header: 'Reason for no Referral', accessorKey: 'noReferralReason', type: 'dropdown', options: ['Already Purchased', 'Client Directed', 'EE Pref Agent - After the Fact', 'Listed at time of auth', 'Listed FSBO', 'Other', 'Relo Benefits Expired', 'Relo Canceled'], required: false, value: listingInfo ? listingInfo.noReferralReason : '', tab: 1 },
    { header: 'Broker Commission %', accessorKey: 'brokerCommission', type: 'number', required: false, value: listingInfo ? listingInfo.brokerCommission : 0, tab: 1 },
    { header: 'Exp. Broker Commission', accessorKey: 'expBrokerCommission', type: 'money', required: false, value: listingInfo ? listingInfo.expBrokerCommission : 0, tab: 1 },
    { header: 'Referral Fee %', accessorKey: 'referralFee', type: 'text', required: false, value: listingInfo ? listingInfo.referralFee : 0, tab: 1 },
    { header: 'Exp. Referral Fee', accessorKey: 'expReferralFee', type: 'money', required: false, value: listingInfo ? listingInfo.expReferralFee : 0, tab: 1 },
    // value: (listingInfo.listPrice && listingInfo.referralFeePercent && listingInfo.brokerCommissionPercent) ? (listingInfo.listPrice * (listingInfo.referralFeePercent / 100) * (listingInfo.brokerCommissionPercent / 100)) : null
    // value: (listingInfo.listPrice && listingInfo.brokerCommissionPercent) ? (listingInfo.listPrice * (listingInfo.brokerCommissionPercent / 100)) : null
    { dividerLine: true, tab: 1 },
    { header: 'Actual Referral Received', accessorKey: 'referralReceived', type: 'money', required: false, value: listingInfo ? listingInfo.referralReceived : 0, tab: 1 },
    { header: 'Fees Collected', accessorKey: 'areFeesCollected', type: 'checkbox', required: false, value: listingInfo ? listingInfo.areFeesCollected : false, tab: 1, Cell: ({ cell }) => <Checkbox name="areFeesCollected" label="Active" checked={cell.row.original.areFeesCollected} disabled={true} /> },
    { header: 'Reason Not Collected', accessorKey: 'reasonNotCollected', type: 'text', required: false, value: listingInfo ? listingInfo.reasonNotCollected : '', tab: 1 },
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newValues = { ...listingInfo };

    newValues.brokerCommission = values.brokerCommission ? parseFloat(values.brokerCommission) : 0;
    newValues.referralFee = values.referralFee ? parseFloat(values.referralFee) : 0;
    newValues.noReferralReason = values.noReferralReason;
    newValues.referralDue = values.referralDue;
    newValues.expReferralFee = values.expReferralFee ? parseFloat(values.expReferralFee) : 0;
    newValues.expBrokerCommission = values.expBrokerCommission ? parseFloat(values.expBrokerCommission) : 0;
    newValues.areFeesCollected = values.areFeesCollected;
    newValues.reasonNotCollected = values.reasonNotCollected;
    newValues.referralReceived = values.referralReceived ? parseFloat(values.referralReceived) : 0;

    const resp = await props.updateListing(newValues, id);
    if (resp.type === UPDATE_LISTINGS_FAILURE) {
      props.showToast('Failed to update broker info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else { 
      setIsLoading(false);
      return true; 
    }
  };
    
  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={3} 
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={isReadOnly}
    />
  );

};

export default compose(
  connect(null, {
    updateListing,
    showToast,
  }),
)(ReferralFeesCard);